// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__4Ft0y","currentCrumb":"Breadcrumbs_currentCrumb__u3Eyr","projectHome":"Breadcrumbs_projectHome__0FD3z"};